import { render, staticRenderFns } from "./Destinos.vue?vue&type=template&id=21d1104d"
import script from "./Destinos.vue?vue&type=script&lang=js"
export * from "./Destinos.vue?vue&type=script&lang=js"
import style0 from "./Destinos.vue?vue&type=style&index=0&id=21d1104d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports